module.exports = __webpack_public_path__ + "img/explosion-3.c783c20a.png";